export const veridionPageJA = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | AI社員による組織",
    "description": "生産性向上の次の段階、Organisation as a Service。AI社員による組織が検証済みの仕事を届けます。固定のサイクルで計画でき、オンプレミスまたはお客様自身のクラウドで稼働します。"
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "一つの創り手、無限の解決策。",
    "claim": "生産性向上の次の段階、Organisation as a Service。",
    "lead": "pAIoneer Labs GmbH全体を動かす社内AI。AI社員からなる働き手が、お客様の会社のあらゆるプロセスに溶け込み、仕事を自ら最後までやり遂げ、任務のひとつひとつとともに学んでいきます。人間が与えるのは方向です。それ以外はすべて自動で進みます。"
  },
  "vision": {
    "lines": [
      "ソフトウェアは企業に道具を与えました。",
      "AIはアシスタントを与えました。",
      "Veridionは組織を与えます。"
    ],
    "note": "情報は数時間で動き、経験は定年とともに去り、空いた席は空いたままです。道具をもう一つ増やしても、それは解決しません。解決するのは、雇い入れる必要のない働き手です。"
  },
  "grow": {
    "title": "できないことは、自ら創り出します",
    "text": "ある課題に対してまだ機能が存在しない場合や、既存の手段では解決できない場合、Veridionは自ら新しい任意に複雑なAIシステムを開発します。つまり「AIがAIを自ら進化させる」のです。設計・構築・検証・稼働までを自律的に行い、最終承認のみを[Intent-Driven Development](idd)（IDD）を通じて人間が担います。",
    "punch": "それこそが、一つの創り手、無限の解決策という意味です。"
  },
  "integrate": {
    "title": "お客様のプロセスの真ん中に",
    "subtitle": "新しいソフトウェアも、研修も、移行作業も要りません。",
    "cards": [
      {
        "title": "社内チャットの中で",
        "text": "会話は、お客様の社員が普段から書いている場所で行われます。Webex、Microsoft Teams、Zoom、Slack。メッセージ一つで十分です。"
      },
      {
        "title": "お客様のツールの中で",
        "text": "プロジェクト管理、リポジトリ、文書の保管。仕事は、いまあるシステムの中で進みます。システムを迂回することはありません。"
      },
      {
        "title": "見積もりから経理まで",
        "text": "一つのプロセスから次のプロセスへ、お客様のペースで。人手が足りないときには、単発の開発パッケージ一つでも、プロジェクト一式でも。"
      }
    ]
  },
  "org": {
    "title": "企業のように編成されたAI社員たち",
    "subtitle": "私たちは固定的なテンプレートを押し付けません。あらゆる企業構造に合わせて個別のオルガニグラム（組織図）を設計し、明確な役割と責任を割り当て、柔軟に適応します。すべてのビジネスユニットはVeridionによってオーケストレーションされたAI社員で構成され、[IDD](idd)のHuman-in-the-Loopまで完全自動で稼働します。そして何かがまだ不可能な場合、Veridionは自ら新しいAIを開発します。",
    "execKicker": "コーディネーション層 — IDD Human-in-the-Loopまで完全自動化",
    "execTitle": "個別の組織図、明確な役割、そしてAIを自ら進化させるAI。",
    "execText": "人間の意思決定者のもとで、コーディネーション層とAI社員によるビジネスユニットは完全自動で稼働します。目標を分解し、明確に定義された役割と責任に業務を配分し、自律的に問題を解決し、人間から的確な承認を取得します。ループ内の人間は[Intent-Driven Development](idd)（IDD）によって全体を統制します。これはソフトウェアコードにとどまらず、意図・決定・検証シナリオを通じて人間とAIが協働する経営・開発手法です。そして必要な能力が欠けているときはいつでも、Veridionが自ら新しい任意に複雑なAIシステムを設計・構築し、AIがAIをさらに進化させます。",
    "units": [
      {
        "name": "ソフトウェア開発",
        "text": "要求から運用までのソフトウェアを担います。アーキテクチャ、コード、テスト、レビュー、パイプライン、そしてその背後にある品質。"
      },
      {
        "name": "エレクトロニクス・ファームウェア",
        "text": "ハードウェアの側面を担います。回路、ファームウェア、そして一つひとつの部品の選定。"
      },
      {
        "name": "量子コンピューティング・量子AI",
        "text": "量子コンピューティングと量子AIの研究を担い、確かな結果を製品に育てます。"
      },
      {
        "name": "営業・マーケティング",
        "text": "市場を担います。動向を観察し、ターゲット顧客を見つけ、調査資料を作成し、文章と提案書を起草します。成約は人間が行います。"
      },
      {
        "name": "プロダクト・プラットフォーム運用",
        "text": "製品と運用を担います。戦略、優先順位、リリース。加えて、稼働中のプラットフォームの監視、障害対応、キャパシティ。"
      },
      {
        "name": "管理・財務",
        "text": "経理と事務の全体を担います。証憑、請求書、契約書、期日。署名の一歩手前まで整え、その署名はお客様のもとに残ります。"
      }
    ]
  },
  "trust": {
    "title": "お客様が頼りにできるもの",
    "cards": [
      {
        "title": "Human-in-the-Loopとコードを超えたIDDの本質",
        "text": "Intent-Driven Development（[IDD](idd)）は単なるソフトウェア開発手法にとどまりません。それはループ内の人間（Human-in-the-Loop）が企業のあらゆる領域でAIと共に行う協働そのものです。人間とAIが共に意図（Intent）を定め、拘束力のある意思決定（Decisions）を下し、検証可能なシナリオ（Scenarios）を定義したうえで、AI社員が固定された計画可能なサイクルで自律実行し、人間が承認します。"
      },
      {
        "title": "ゲーム理論で最適化されたコミュニケーション",
        "text": "プロジェクト管理とAI社員のコミュニケーションは、一人のAI社員からビジネスユニット全体に至るまで、ゲーム理論で最適化されています。綿密さと根拠のある異議は報われ、素通しの承認、繰り返し、責任の押し付けは損失になります。こうして、最良のコミュニケーションが勝ち残ります。"
      },
      {
        "title": "出典まで説明できる",
        "text": "Explainable AIは、ここでは仕事の原則であり、付け足しではありません。すべての成果は、何から生まれたのかを明らかにします。企業ナレッジの中の該当箇所、データ、計算の道筋。裏付けのないことは、主張されません。"
      },
      {
        "title": "自ら学びます",
        "text": "一巡するごとに自らの指標を読み、それに応じて自らの規則を調整します。進行中のプロジェクトの一つひとつが、全体をより良くしていきます。"
      }
    ]
  },
  "daily": {
    "title": "この組織が今日すでに引き受けている仕事",
    "subtitle": "毎日、企業全体を横断して。",
    "items": [
      {
        "title": "開発",
        "text": "記録された意思決定から、コード、テスト、ドキュメントを生み出します。年月を経たソフトウェアの近代化は、ゴールデンマスターテストとバックツーバックテストで証明します。"
      },
      {
        "title": "エレクトロニクスとファームウェア",
        "text": "データシートを分析し、回路をデジタルツインとしてシミュレーションし、ファームウェアを開発し、何かが製造される前に部品の代替案を評価します。センサーに至るまで、ハードウェアの近くで。"
      },
      {
        "title": "量子研究",
        "text": "技術の最先端を読み、古典的な比較基準に対する再現可能な実験を組んで評価します。すべての結果は、たどれる形で記録されます。"
      },
      {
        "title": "データ分析",
        "text": "SQL Server、MariaDB、MySQL、Oracle。型付きの分析計画、読み取り専用のクエリ、実行環境が計算する統計、バージョン管理された一つの結果から生成されるレポート。"
      },
      {
        "title": "管理と財務",
        "text": "簿記、会計、そして会社運営に伴う事務手続き。証憑を読み取り、仕分けし、保管します。請求書と契約書の下書きも含まれます。"
      },
      {
        "title": "プロジェクトとタスク",
        "text": "会議の議事録は回り道なくプロジェクト管理のタスクになり、進捗は還流して、次の会議は最新の状況から始まります。"
      },
      {
        "title": "企業ナレッジ",
        "text": "文書のためのナレッジベースと、タスク、意思決定、人、システムを結び付けるグラフデータベース。週をまたぎ、プロジェクトの境界を越えて、文脈がつながります。"
      },
      {
        "title": "インターネット調査",
        "text": "企業ナレッジにないものは調査します。検索し、最良のページを読み、最後には、すべての記述に番号付きの出典が付いたレポートが残ります。"
      },
      {
        "title": "音声と会議",
        "text": "会社全体を、移動中でも率いることができます。話し言葉での対話は、チャットと同じ仕事を片付けます。外出先の携帯電話からでも。"
      },
      {
        "title": "RoBuddyによる事務作業",
        "text": "RoBuddyが職場を受け持ちます。予定、メール、研修、データ保護に関する質問。企業の残りは、各ユニットが担います。"
      }
    ]
  },
  "operate": {
    "title": "導入と運用",
    "cards": [
      {
        "title": "オンプレミスまたはお客様自身のクラウド",
        "text": "事前に、どのプロセスが見合うかをお客様とともに計算します。投資対効果も総コストも、包み隠さず示されます。運用はお客様のハードウェア上、またはお客様自身のクラウドで。文書が社外に出ることはありません。"
      },
      {
        "title": "当社では",
        "text": "pAIoneer Labs GmbHは、土台からこの形で築かれています。当社のプロジェクト、企業ナレッジ、管理業務が、この上で動いています。当社プラットフォームの[トレーディングアシスタント](finance)は、この組織が自ら開発しており、そのチャットの中のAIも、この組織です。"
      }
    ]
  },
  "cta": {
    "title": "お問い合わせ",
    "subtitle": "サーバーソフトウェアとして、お客様のインフラの中へ。価格はお問い合わせに応じてご案内します。",
    "button": "お問い合わせを送る",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
